import { motion } from "framer-motion";

export const Seal = ({ size = 180 }) => (
    <motion.div
        data-testid="prepaid-seal"
        initial={{ scale: 1.7, opacity: 0, rotate: -18 }}
        animate={{ scale: 1, opacity: 1, rotate: -6 }}
        transition={{ duration: 0.7, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
        style={{ width: size, height: size }}
        className="relative mx-auto drop-shadow-[0_0_35px_rgba(201,221,238,0.35)]"
        aria-label="Pre-paid — sealed by Savv"
    >
        <svg viewBox="0 0 200 200" className="w-full h-full">
            <circle cx="100" cy="100" r="96" fill="#0C0C0C" stroke="#C9DDEE" strokeWidth="2.5" />
            <circle cx="100" cy="100" r="86" fill="none" stroke="#C9DDEE" strokeWidth="1" strokeDasharray="3 5" />
            <g className="spin-slow" style={{ transformOrigin: "100px 100px" }}>
                <defs>
                    <path id="seal-ring" d="M100,100 m-72,0 a72,72 0 1,1 144,0 a72,72 0 1,1 -144,0" />
                </defs>
                <text fill="#161616" fontSize="12.5" letterSpacing="3.5" fontFamily="'Inter', sans-serif" fontWeight="600">
                    <textPath href="#seal-ring">
                        PRE-PAID ✦ SEALED BY SAVV ✦ SAVV MEDIA ✦ EST. 2018 ✦
                    </textPath>
                </text>
            </g>
            <circle cx="100" cy="100" r="52" fill="none" stroke="#C9DDEE" strokeWidth="1.5" />
            <path
                d="M100 128 C82 114 70 102 70 89 C70 78.5 78.5 71 88.5 71 C94 71 98.2 74.6 100 78.4 C101.8 74.6 106 71 111.5 71 C121.5 71 130 78.5 130 89 C130 102 118 114 100 128 Z"
                fill="none"
                stroke="#C9DDEE"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <text
                x="100"
                y="152"
                textAnchor="middle"
                fill="#F1F1EF"
                fontSize="11"
                letterSpacing="4"
                fontFamily="'Inter', sans-serif"
                fontStyle="italic"
            >
                savv approved
            </text>
        </svg>
    </motion.div>
);
